const toNumericSegments = (version: string) =>
  version.split('.').map((segment) => Number.parseInt(segment, 10) || 0)

export const compareVersions = (a: string, b: string) => {
  const segmentsA = toNumericSegments(a)
  const segmentsB = toNumericSegments(b)
  const length = Math.max(segmentsA.length, segmentsB.length)

  for (let index = 0; index < length; index += 1) {
    const difference = (segmentsA[index] ?? 0) - (segmentsB[index] ?? 0)
    if (difference !== 0) return difference < 0 ? -1 : 1
  }

  return 0
}

export const isVersionGreater = (a: string, b: string) => compareVersions(a, b) > 0

export const isVersionLower = (a: string, b: string) => compareVersions(a, b) < 0
